import CssBaseline from "@mui/material/CssBaseline";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "./components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ProjectProvider } from "./contexts/ProjectContext";
import { OrganizationProvider } from "./contexts/OrganizationContext";
import { router } from "./router";
import "./theme/designSystemVariables.css";

import "./i18n";

import i18n from "i18next";
import {
  applyLanguageToDocument,
  getPersistedLanguage,
} from "./utils/language";

applyLanguageToDocument(
  i18n.resolvedLanguage || i18n.language || getPersistedLanguage(),
);

const queryClient = new QueryClient();

/**
 * The provider stack stays OUTSIDE the router, exactly where it sat when
 * <Router> lived here. None of these four providers use router hooks, which is
 * what makes swapping the router underneath them a local change.
 *
 * TanStack Router now owns the root. Every path still falls through to the
 * legacy react-router tree via the catch-all routes in src/routes/ — see
 * src/legacy-routes.jsx. Screens migrate out by adding a real route file, which
 * takes precedence over the catch-all.
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <OrganizationProvider>
          <ProjectProvider>
            <ThemeProvider>
              <CssBaseline />
              <RouterProvider router={router} />
              <Toaster />
            </ThemeProvider>
          </ProjectProvider>
        </OrganizationProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
